/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type RsiPageCheckEnum = typeof RsiPageCheckEnum[keyof typeof RsiPageCheckEnum];


export const RsiPageCheckEnum = {
  MISSING_LIST: 'missing_list',
  MISSING_PLEDGE_IDS: 'missing_pledge_ids',
  MISSING_KINDS: 'missing_kinds',
  UNKNOWN_KINDS: 'unknown_kinds',
  MISSING_ENTRIES: 'missing_entries',
  UNPARSED_ENTRIES: 'unparsed_entries',
} as const;
